import { render, staticRenderFns } from "./axisCoordinates-editor.vue?vue&type=template&id=6f064622&scoped=true"
import script from "./axisCoordinates-editor.vue?vue&type=script&lang=js"
export * from "./axisCoordinates-editor.vue?vue&type=script&lang=js"
import style0 from "./axisCoordinates-editor.vue?vue&type=style&index=0&id=6f064622&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f064622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f064622')) {
      api.createRecord('6f064622', component.options)
    } else {
      api.reload('6f064622', component.options)
    }
    module.hot.accept("./axisCoordinates-editor.vue?vue&type=template&id=6f064622&scoped=true", function () {
      api.rerender('6f064622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/axisCoordinates-editor.vue"
export default component.exports